module.exports = __webpack_public_path__ + "static/media/29BDOS2.4a5a6b69.jpg";